import { StyleType } from '@wix/editor-platform-ooi-metadata-resolver';
import { StyleParamType, createStylesParams } from '@wix/tpa-settings';
import { RssWidgetIconType } from '@wix/communities-blog-client-common';

export default createStylesParams<{
  'widget-iconColor': StyleParamType.Color;
  'widget-iconBackgroundColor': StyleParamType.Color;
  'widget-iconColorNoBackground': StyleParamType.Color;
  'widget-iconBackgroundType': StyleParamType.Number;
}>({
  'widget-iconColor': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'rgb(255,255,255)',
        opacity: 1,
      },
    },
    getDefaultValue: () => ({
      value: 'rgb(255,255,255)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconBackgroundColor': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'rgb(250,173,77)',
        opacity: 1,
      },
    },
    getDefaultValue: () => ({
      value: 'rgb(250,173,77)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconColorNoBackground': {
    type: StyleParamType.Color,
    metadata: {
      type: StyleType.color,
      defaultValue: {
        type: 'static',
        preset: 'rgb(250,173,77)',
        opacity: 1,
      },
    },
    getDefaultValue: () => ({
      value: 'rgb(250,173,77)',
      name: null,
      opacity: 1,
    }),
  },
  'widget-iconBackgroundType': {
    type: StyleParamType.Number,
    metadata: {
      type: StyleType.UNKNOWN_CssPropertyType,
      defaultValue: {
        type: 'static',
        value: RssWidgetIconType.Square,
      },
    },
    getDefaultValue: () => RssWidgetIconType.Square,
  },
});
